// NotesList.tsx
import { useEffect, useRef } from 'react';
import { formatDistanceToNow } from 'date-fns';
import {Note} from "../models";
import {toTitleCase} from "../../createApplication/utils";
import {getDataAndTime} from "../utils";

export const NotesList = ({
                            notes,
                            userDetails,
                          }: {
  notes: Note[];
  userDetails: any;
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [notes]);

  return (
      <div className="flex-1 overflow-y-auto px-4 py-2">
        <div className="space-y-4">
          {notes.map((note, index, notes) => {
            const isCurrentUser = note.author === userDetails?.userName;

            return (
                <div key={`note-${note.createDateTime}-${index}`}>
                  {(index === 0 ||
                      new Date(note.createDateTime).toLocaleDateString() !==
                      new Date(notes[index - 1].createDateTime).toLocaleDateString()) && (
                      <div className="sticky top-0 z-10 flex justify-center my-4">
                  <span className="px-3 py-1 text-xs bg-gray-200 rounded-full text-gray-600">
                    {new Date(note.createDateTime).toLocaleDateString()}
                  </span>
                      </div>
                  )}
                  <div
                      className={`flex ${
                          isCurrentUser ? 'justify-end' : 'justify-start'
                      } mb-4`}
                  >
                    <div className={`flex flex-col max-w-[70%] ${
                        isCurrentUser ? 'items-end' : 'items-start'
                    }`}>
                      <div className={`flex items-center space-x-2 mb-1 ${
                          isCurrentUser ? 'justify-end w-full' : 'justify-start w-full'
                      }`}>
                    <span className="text-sm font-medium text-gray-700">
                      {toTitleCase(note.author)}
                    </span>
                      </div>
                      <div
                          className={`p-3 rounded-lg ${
                              isCurrentUser
                                  ? 'bg-blue-500 text-white rounded-tr-none'
                                  : 'bg-gray-200 text-gray-800 rounded-tl-none'
                          }`}
                      >
                        <p className="text-sm">{note.notes}</p>
                      </div>
                      <span className={`text-xs text-gray-500 mt-1 ${
                          isCurrentUser ? 'text-right' : 'text-left'
                      } w-full`}>
                    {getDataAndTime(note.createDateTime)}
                  </span>
                    </div>
                  </div>
                </div>
            );
          })}
          <div ref={messagesEndRef} />
        </div>
      </div>
  );
};
